import localForage from "localforage";
import { COMMON_ALERT_OPEN } from './commonActions';

export const AUTH_SIGN_IN = 'AUTH_SIGN_IN';
export const AUTH_SIGN_IN_SUCCESS = 'AUTH_SIGN_IN_SUCCESS';
export const AUTH_SIGN_OUT = 'AUTH_SIGN_OUT';

export const AUTH_RESET_PASSWORD = 'AUTH_RESET_PASSWORD';
export const AUTH_RESET_PASSWORD_SUCCESS = 'AUTH_RESET_PASSWORD_SUCCESS';

export const AUTH_RESET_PASSWORD_REQUEST = 'AUTH_RESET_PASSWORD_REQUEST';
export const AUTH_RESET_PASSWORD_REQUEST_SUCCESS = 'AUTH_RESET_PASSWORD_REQUEST_SUCCESS';


export const signIn = (formData) => {
  return {
    type: AUTH_SIGN_IN,
    payload: {
      request: {
        url: 'auth/login/',
        data: formData,
        method: 'post',
        headers: {
          'Accept': 'application/json',
          'Accept-Language': 'es'
        }
      },
      options: {
        onSuccess({ getState, dispatch, response }) {
          localForage.setItem('account', response.data).then(() => {
            dispatch({ type: AUTH_SIGN_IN_SUCCESS, payload: response.data });
          })
        },
        onError({ getState, dispatch, error }) {

          let message = 'Network error';

          if (typeof error.response !== 'undefined') {
            message = typeof error.response.data.error !== 'undefined' ? error.response.data.error : 'Error';
          }

          dispatch({
            type: COMMON_ALERT_OPEN, alert: {
              open: true,
              type: 'error',
              message: message
            }
          });
        },
      }
    }
  }
};

export const resetPassword = (formData) => {
  return {
    type: AUTH_RESET_PASSWORD,
    payload: {
      request: {
        url: 'auth/password_recovery_process/',
        data: formData,
        method: 'post',
        headers: {
          'Accept': 'application/json',
          'Authorization': 'Token 5e41b23c3d2b2cc25b1514e3a90af0c252a739dc',
          'Accept-Language': 'es'
        }
      },
      options: {
        onSuccess({ getState, dispatch, response }) {
          localForage.setItem('auth', response.data).then(() => {
            dispatch({ type: AUTH_RESET_PASSWORD_SUCCESS, payload: response.data });
          })
        },
        onError({ getState, dispatch, error }) {

          let message = 'Network error';

          if (typeof error.response !== 'undefined') {
            message = typeof error.response.data.error !== 'undefined' ? error.response.data.error : 'Error';
          }

          dispatch({
            type: COMMON_ALERT_OPEN, alert: {
              open: true,
              type: 'error',
              message: message
            }
          });
        },
      }
    }
  }
}

export const resetPasswordRequest = (formData) => {
  return {
    type: AUTH_RESET_PASSWORD_REQUEST,
    payload: {
      request: {
        url: 'auth/password_recovery_request/',
        data: formData,
        method: 'post',
        headers: {
          'Accept': 'application/json',
          'Accept-Language': 'es'
        }
      },
      options: {
        onSuccess({ getState, dispatch, response }) {
          dispatch({ type: AUTH_RESET_PASSWORD_REQUEST_SUCCESS, payload: response.data });
        },
        onError({ getState, dispatch, error }) {

          let message = 'Network error';

          if (typeof error.response !== 'undefined') {
            message = typeof error.response.data.error !== 'undefined' ? error.response.data.error : 'Error';
          }

          dispatch({
            type: COMMON_ALERT_OPEN, alert: {
              open: true,
              type: 'error',
              message: message
            }
          });
        },
      }
    }
  }
}

export function signOut() {
  return {
    type: AUTH_SIGN_OUT
  };
}




// WEBPACK FOOTER //
// ./src/redux/actions/authActions.js